<template>
  <div class="alert">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props:['type', 'message']
  }
</script>